export const CheckForOverlappingShifts = async ({
  startTime,
  endTime,
  employees,
  allEmployees,
  shifts,
  date,
  allProjects,
  existingShiftId = null,
}) => {
  if (!startTime || !endTime || !employees || employees.length === 0) {
    return null;
  }

  const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  };

  let newShiftStart = timeToMinutes(startTime);
  let newShiftEnd = timeToMinutes(endTime);

  // Hantera övernattande pass
  if (newShiftEnd <= newShiftStart) newShiftEnd += 1440;

  const employeeIds = employees
    .map((emp) => emp?.employeeId)
    .filter((id) => !!id);

  const overlappingShifts = shifts.filter((shift) => {
    if (shift.date !== date || shift._id === existingShiftId) return false;

    let shiftStart = timeToMinutes(shift.startTime);
    let shiftEnd = timeToMinutes(shift.endTime);

    // Hantera övernattande pass
    if (shiftEnd <= shiftStart) shiftEnd += 1440;

    // 1 minut marginal: inga konflikter om ett skift slutar t.ex. 21:00 och nästa börjar exakt 21:00
    const timeOverlaps = shiftStart < newShiftEnd - 1 && shiftEnd > newShiftStart + 1;

    const employeeConflict = shift.employees.some((e) =>
      employeeIds.includes(e.employeeId)
    );

    return timeOverlaps && employeeConflict;
  });

  if (overlappingShifts.length > 0) {
    let conflictDetails = [];

    overlappingShifts.forEach((shift) => {
      shift.employees.forEach((empObj) => {
        if (employeeIds.includes(empObj.employeeId)) {
          const employee = allEmployees.find(
            (e) => e._id === empObj.employeeId
          );
          const matchingProject = allProjects.find(
            (project) => project._id === shift.project
          );

          if (employee) {
            conflictDetails.push({
              employeeName: employee.name,
              projectName: matchingProject ? matchingProject.name : "Okänt projekt",
              shiftTime: `${shift.startTime} - ${shift.endTime}`,
            });
          }
        }
      });
    });

    let warningMessage = `🛑 VARNING: Följande anställda har redan ett pass under denna tid idag:\n\n`;

    conflictDetails.forEach((conflict) => {
      warningMessage += `${conflict.employeeName} [${conflict.projectName}, ${conflict.shiftTime}]\n\n`;
    });

    return warningMessage;
  }

  console.log("✅ Inga överlappande pass hittades.");
  return null;
};
